export const ItemsPerPageOptions = [10, 50, 100, 1000, 2500];
